import * as elementsAPI from '@motionelements/core/src/api/elements.js';
import { isProductType } from '@motionelements/core/src/services/catalog.service.js';

// import createDownloadVideoFileMock from '@/mock/createDownloadVideoFile.json';

export default {
  fetchOnServer: true,
  data() {
    return {
      productSku: null,
    };
  },
  mounted() {
    if (this.productId) {
      this.getProductInfo();
    }
  },
  methods: {
    getProductInfo() {
      this.isLoading = true;
      return elementsAPI.getElement(this.productId)
        .then(({ data: { data: product } }) => {
          this.$store.commit('tool/setProduct', _.pick(product, ['html']));
          if (isProductType('video', _.get(product, 'mediaType', ''))) {
            // this.inputFilePreview = 'https://thumb.r2.moele.me/t/1322/9312315/a-0200.jpg';
            // this.form.video = 'https://video.r2.moele.me/v/1322/9312315_a-01.mp4';
            this.inputFilePreview = _.get(product, 'thumbnails.jpg.url', '');
            this.form.video = _.get(product, 'previews.mp4.url', '');
            this.width = _.get(product, 'variants[0].width', 0);
            this.height = _.get(product, 'variants[0].height', 0);
            this.duration = _.get(product, 'variants[0].duration', 0);
            //
            const masterVariant = _.get(product, 'variants', []).find(({ master }) => master);
            this.productSku = _.get(masterVariant, 'id');
          } else {
            console.log('%c CURRENT PRODUCT IS NOT A VIDEO!', 'color: red');
            this.isError = true;
            throw Error('current product is not video');
          }
        })
        .catch((err) => {
          console.error(err);
          this.isError = true;
          throw Error(err);
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
  },
};
